export default function ScrollToTargetAdjusted(id) {
    setTimeout(() => {
        var element = document.getElementById(id);
        if (element) {
            var headerOffset = 100;
            var elementPosition = element.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        } else {
            console.log("No element found with id:", id)
        }

    }, 500)


}